import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import api from '../../../api/Categories.api';
import { hashHistory, Link } from 'react-router';
import withSelection from './../../../reusable/LightTable/hoc/Selectable';
import LightTable from './../../../reusable/LightTable/VeryLightTable';
import { DeleteButton } from './../../../reusable/Form/Buttons';
import dateFormat from 'dateformat';
import popupActions from '../../../reusable/MessagePopup/redux/MessagePopup.actions';
import { SORT, POPUP_LIFETIME } from '../../../constants';

const Table = withSelection(LightTable);

const defaultLoadParams = {
    filters: { query: "" },
    sorting: { sortBy: "name", direction: SORT.ASC },
    pagination: { pageNumber: 0 },
    reset: false
};

export default class EmptyCategoriesTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryNames: {},
            listItems: null,
            currentPage: 0,
            totalCount: 0,
            filterCount: 0,
            loadParams: defaultLoadParams,
            selectedItems: [],
            searchTerm: ""
        };

        this.loadItems = this.loadItems.bind(this);
        this.handleErrorState = this.handleErrorState.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.selectAllToggle = this.selectAllToggle.bind(this);
    }

    componentWillMount() {
        this.loadItems();
    }


    loadItems() {
        return api.getEmptyCategoriesCount().then((countRes) => {
            if(countRes.body === 0) {
                this.props.resetImpendingCategoryDeletion();
                return;
            }
            return api.getEmpty().then((response) => {
                const items = response.body.map(item => {
                    item.busy = false;
                    return item;
                });

                this.setState({
                    listItems: items,
                    totalCount: countRes.body
                });
                return this.state.listItems
            })
        }).catch((error) => {
            this.handleErrorState();
        })
    }

    selectAllToggle() {
        if (this.state.selectedItems.length === this.state.totalCount) {
            this.setState({ selectedItems: [] })
        } else {
            this.setState({ selectedItems: this.state.listItems.map(item => this.formatCategoryItem(item)) })
        }
    }

    editCategory = (category) => (e) => {
        hashHistory.push(`/categories/${category.id}`);
    };

    /**
     * View function for items in table
     * @param item
     * @param searchTerm
     * @returns {{key, companyTitle: XML, status: string, duns: (string|string|*), categoryIDs: XML, object: *}}
     */
    formatCategoryItem = (item, searchTerm = "") => {
        return { // TODO: separate cells from functional fields
            key: item.id,
            name: item.name,
            lastUpdated: item.lastUpdated && dateFormat(new Date(item.lastUpdated), "mmm dd, yyyy HH:MM"),
            actions: <div>
                <Link to={"/categories/" + item.id} className={'action-btn'}>
                    <FormattedMessage id="General_CoreFunctionality_UIText_general.edit" />
                </Link>
            </div>,
            object: item
        }
    };

    /**
     * View function for item in selected box
     * @param item
     */
    formatSelectedItem = (item) => <span>{item.name}</span>;

    /**
     * Handler for selection change
     * @param selectedItems
     */
    onChange = (selectedItems) => {
        this.setState({ selectedItems });
        if (this.props.onChange) {
            this.props.onChange(selectedItems.map(item => item.object.id));
        }
    };

    handleDelete = () => {
        let emptyCatsIds = [];
        for (let i = 0; i < this.state.selectedItems.length; i++) {
            emptyCatsIds.push(this.state.selectedItems[i].key);
        }
        api.deleteCategories(emptyCatsIds)
            .then((response) => {
                this.setState({ selectedItems: [] });
                this.loadItems();
                popupActions.setMessages({
                    popupTitle: null,
                    messages:   [
                        {
                            messageId:   'Category_Manage_UIText_bulkDeleteCategory.successMessage',
                            messageType: 'success'
                        }
                    ]
                });

                // Hide the message after 5 seconds.
                setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
            })
            .catch((error) => {
                popupActions.setMessages({
                    popupTitle: null,
                    messages:   [
                        {
                            messageId:   'General_CoreFunctionality_UIText_general.genericErrorMsg',
                            messageType: 'system-error'
                        }
                    ]
                });

                // Hide the message after 5 seconds.
                setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
            });

    };

    /**
     * Resets state in case of error
     */
    handleErrorState() {
        console.log('Error catched');
        this.setState({
            listItems: [],
            totalCount: 0,
            itemCount: 0,
            hasError: true
        })
    }

    headerItems = [
        {
            key: "name",
            label: <FormattedMessage id='Category_Manage_UIText_tableHeaderElement.category'/>,
            sortable: true
        },
        {
            key: "lastUpdated",
            label: <FormattedMessage id={"RSS_Feed_UIText_feedListing.lastUpdated"}/>
        },
        {
            key: "actions",
            label: ""
        }
    ]

    defaultSort = { sortBy: "name", direction: SORT.ASC }

    render = () =>
        <div className="selectable-table empty-category-table">
            <Table headerItems={this.headerItems}
                   listItems={this.state.listItems ? this.state.listItems.map(item => this.formatCategoryItem(item, this.state.searchTerm)) : null}
                   className="selectable-table"
                   totalCount={this.state.totalCount}
                   itemCount={this.state.filterCount}
                   onSelectionChange={this.onChange}
                   selectedItems={this.state.selectedItems}
                   selectAllToggle={this.selectAllToggle}
                   formatSelectedItem={this.formatSelectedItem}
                   actions={<DeleteButton action={this.handleDelete} disabled={this.state.selectedItems.length === 0} />}
                   { ...this.props } />
        </div>
}


// WEBPACK FOOTER //
// ./src/scripts/pages/Categories/Components/EmptyCategoriesTable.jsx